import UserAccount from "./UserAccount.mjs";
import { query, showElement, hideElement, updateAlert } from "../utils.mjs";
import WindCreekClient from "./WindCreekClient.mjs";
import { profileAnimation } from "./my-rewards-animations.mjs";

UserAccount.windCreekClient = new WindCreekClient();

let loginTypes = UserAccount.getLoginTypes();

let profilePage = query("[data-profile-page]");

// This function populates the profile data on the page
function setupProfilePage(accountData, profileData) {
  if (UserAccount.isMiamiSite()) {
    const profileInfo = [
      [
        {
          label: "Name",
          value:
            profileData.patronInfo.firstName +
            " " +
            profileData.patronInfo.lastName,
        },
        {
          label: "Join Date",
          value: profileData.patronInfo.rewardsJoinDate
            .replace(/^0/, "")
            .replace(/\/0/, "/"),
        },
        {
          label: "Birthday",
          value: profileData.patronInfo.birthDate
            .replace(/^0/, "")
            .replace(/\/0/, "/"),
        },
      ],
      [
        {
          label: "Rewards Number",
          value: profileData.patronAccountNumber,
        },
      ],
      [
        {
          label: "Primary Address",
          value: buildAddress(profileData.patronInfo),
        },
      ],
      [
        {
          label: "Email",
          value: profileData.patronInfo.email,
        },
      ],
      [
        {
          label: "Mobile Phone",
          value: formatPhoneNumber(profileData.patronInfo.mobilePhone),
        },
        {
          label: "Home Phone",
          value: formatPhoneNumber(profileData.patronInfo.homePhone),
        },
      ],
    ];

    if (profileData.patronInfo.accountCard) {
      profileInfo[1].push({
        label: `${profileData.patronInfo.accountCard.cardType} Card Number`,
        value: profileData.patronInfo.accountCard.cardNumber,
      });
    }

    if (profileData.patronInfo.addressOther.length > 0) {
      profileData.addressOther.forEach((address) => {
        profileInfo[2].push({
          label: `${address.addressType} Address`,
          value: buildAddress(address),
        });
      });
    }

    if (profileData.patronInfo.emailOther.length > 0) {
      profileData.emailOther.forEach((email, i) => {
        profileInfo[3].push({
          label: `${email.emailType} Email ${i + 1}`,
          value: email.email,
        });
      });
    }

    if (profileData.patronInfo.phoneOther.length > 0) {
      profileData.phoneOther.forEach((phone, i) => {
        profileInfo[4].push({
          label: `${phone.phoneType} Phone ${i + 1}`,
          value: formatPhoneNumber(phone),
        });
      });
    }

    const profileInfoContainer = profilePage.querySelector(
      "[data-profile-info]"
    );
    profileInfo.forEach((group) => {
      const groupContainer = document.createElement("div");
      groupContainer.classList.add('profile-group', 'bg-light', 'rounded', 'p-3', 'p-md-4');
      let groupHTML = `<div class="row gy-4">`;
      group.forEach((info) => {
        if (info.value) {
          groupHTML += `
          <div class="col-md-6 col-lg-4">
            <div class="profile-info">
              <span class="d-block label-2 mb-1 text-secondary">${info.label}</span>
              <div class="d-block subhead-3">${info.value}</div>
            </div>
          </div>
        `;
        }
      });
      profileInfoContainer.appendChild(groupContainer);
      groupContainer.innerHTML = groupHTML;
    });

    //Add the text after the profile info
    const textContainer = document.createElement("div");
    const profileText = `<p class='profile-info mb-0 mt-3'>To make changes to this information, visit <span class='text-uppercase'>Guest Services</span> in person at any Wind Creek Casino.</p>`;
    profileInfoContainer.appendChild(textContainer);
    textContainer.innerHTML = profileText;

    profileAnimation();
  } else {
    profilePage.querySelector("[data-email]").textContent =
      profileData.patronInfo.email;

    profilePage.querySelector("[data-birthday]").textContent =
      profileData.patronInfo.birthDate.replace(/^0/, "").replace(/\/0/, "/");

    profilePage.querySelector("[data-address]").innerHTML = buildAddress(
      profileData.patronInfo
    );

    if (
      profileData.patronInfo?.mobilePhone &&
      profileData.patronInfo.mobilePhone !== "not found"
    ) {
      profilePage.querySelector(
        "[data-profile-mobile-phone-value]"
      ).textContent = profileData.patronInfo.mobilePhone;
      showElement("[data-profile-mobile-phone]");
    }

    if (
      profileData.patronInfo?.homePhone &&
      profileData.patronInfo.homePhone !== "not found"
    ) {
      profilePage.querySelector("[data-profile-home-phone-value]").textContent =
        profileData.patronInfo.homePhone;
      showElement("[data-profile-home-phone]");
    }

    profilePage.querySelector("[data-join-date]").textContent =
      profileData.patronInfo.rewardsJoinDate
        .replace(/^0/, "")
        .replace(/\/0/, "/");

  }

  // Populate the fields in the profile update form with the existing values
  accountData.email = accountData?.email || '';
  accountData.displayName = accountData?.displayName || '';
  accountData.preferredLocation = accountData?.preferredLocation || '';

  profilePage.querySelector('[name="email"]').value = accountData.email;
  profilePage
    .querySelector('[name="email"]')
    .setAttribute("data-original-value", accountData.email);
  profilePage.querySelector('[name="display-name"]').value =
    accountData.displayName;
  profilePage
    .querySelector('[name="display-name"]')
    .setAttribute("data-original-value", accountData.displayName);
  profilePage.querySelector('[name="preferred-location"]').value =
    accountData.preferredLocation;
  profilePage
    .querySelector('[name="preferred-location"]')
    .setAttribute("data-original-value", accountData.preferredLocation);
}

// Checks to see if a field in the API response exists and has a useful, non-empty value in it
function fieldExists(fieldName, object) {
  return (
    object[fieldName] &&
    object[fieldName] !== "not found" &&
    object[fieldName] !== "not specified"
  );
}

// Generates the formatted address HTML for display using the address data from the API
function buildAddress(patronInfo) {
  let address = "";

  let cityFound = false;
  let stateProvinceFound = false;

  if (fieldExists("address1", patronInfo)) {
    address += patronInfo.address1;
  }

  if (fieldExists("address2", patronInfo)) {
    address += "<br>" + patronInfo.address2;
  }

  if (fieldExists("city", patronInfo)) {
    address += "<br>" + patronInfo.city;
    cityFound = true;
  }

  if (fieldExists("stateProvince", patronInfo)) {
    if (cityFound) {
      address += ", ";
    } else {
      address += "<br>";
    }

    address += patronInfo.stateProvince;

    stateProvinceFound = true;
  }

  if (fieldExists("postalCode", patronInfo)) {
    if (cityFound || stateProvinceFound) {
      address += " ";
    } else {
      address += "<br>";
    }

    address += patronInfo.postalCode;
  }

  return address;
}

// Formats a phone number string into a standard format
function formatPhoneNumber(phoneNumberString) {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    let intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

if (profilePage) {
  if (UserAccount.isLoggedIn()) {
    // The user has an existing session. Call the API to retrieve the correct account and profile data based on the login type.
    let loginType = UserAccount.getLoginType();
    if (loginType === loginTypes.EMAIL_PASSWORD) {
      /*
      Getting all the necessary data requires multiple API calls, so we need to wait for everything to finish
      (i.e. wait for all the promises to resolve)
      */
      Promise.all([UserAccount.getAccountData(), UserAccount.getProfile()])
        .then(([accountData, profileData]) => {
          setupProfilePage(accountData, profileData);
          profilePage.classList.remove("loading-animation");
        })
        .catch((error) => {
          showElement("[data-page-error-message]");
          hideElement("[data-hide-on-page-error]");
          profilePage.classList.remove("loading-animation");
          console.log("unable to load account or profile data");
          console.error(error);
          newrelic.noticeError(error);
        });
    } else {
      UserAccount.getProfile()
        .then((profileData) => {
          let accountData = {}; // Logging in with rewards number + PIN doesn't grant access to the online account data, so set this to an empty object
          setupProfilePage(accountData, profileData);
          profilePage.classList.remove("loading-animation");
        })
        .catch((error) => {
          showElement("[data-page-error-message]");
          hideElement("[data-hide-on-page-error]");
          profilePage.classList.remove("loading-animation");
          console.log("unable to load profile data");
          console.error(error);
          newrelic.noticeError(error);
        });
    }

    // If the user logged in with an email and password, then they can use the form to update their online casino account info
    if (loginType === loginTypes.EMAIL_PASSWORD) {
      const profileForm = profilePage.querySelector("[data-profile-form]");
      if (profileForm) {
        // Handle the form submit event for the profile update form
        profileForm.addEventListener("submit", (event) => {
          event.preventDefault();

          let fields = {
            email: {
              updateFunction: UserAccount.setEmail.bind(UserAccount),
              errorMessage: "Sorry, we couldn't update your email address.",
            },
            "display-name": {
              updateFunction: UserAccount.setDisplayName.bind(UserAccount),
              errorMessage: "Sorry, we couldn't update your display name.",
            },
            "preferred-location": {
              updateFunction:
                UserAccount.setPreferredLocation.bind(UserAccount),
              errorMessage:
                "Sorry, we couldn't update your preferred location.",
            },
          };

          let formData = new FormData(event.target);

          // This form needs to support multiple messages (one for each API call that happens for each updated field)
          // We're using a <template> tag in the HTML as our alert template
          let messageContainer = profilePage.querySelector(
            "[data-update-result-message-container]"
          );
          messageContainer.innerHTML = "";
          let messageTemplate = profilePage.querySelector(
            "#profile-update-message-template"
          );

          for (let fieldKey in fields) {
            let newValue = formData.get(fieldKey);
            let oldValue = profileForm
              .querySelector(`[name="${fieldKey}"]`)
              .getAttribute("data-original-value");

            // Only do the API call if the value actually changed
            if (newValue !== oldValue) {
              fields[fieldKey]
                .updateFunction(newValue)
                .then((result) => {
                  let messageText = "";
                  let messageStyle = "";

                  if (
                    fieldKey === "preferred-location" &&
                    result?.preferredLocation === newValue
                  ) {
                    // The response structure of the setPreferredLocation call is a little different from the others
                    messageStyle = "success";
                    messageText = `Preferred location successfully changed to ${newValue}.`;
                    profileForm
                      .querySelector(`[name="${fieldKey}"]`)
                      .setAttribute("data-original-value", newValue);
                  } else if (result?.success === true) {
                    messageStyle = "success";
                    messageText = result?.message;
                    profileForm
                      .querySelector(`[name="${fieldKey}"]`)
                      .setAttribute("data-original-value", newValue);
                  } else {
                    messageStyle = "danger";
                    messageText =
                      result?.message ?? fields[fieldKey].errorMessage;
                    console.error(`unable to update ${fieldKey}`, result);
                  }

                  let message = messageTemplate.content.cloneNode(true);
                  let alertElement = message.querySelector(".alert-area");
                  updateAlert(alertElement, messageText, messageStyle);
                  messageContainer.appendChild(message);
                })
                .catch((error) => {
                  let message = messageTemplate.content.cloneNode(true);
                  let alertElement = message.querySelector(".alert-area");
                  updateAlert(
                    alertElement,
                    fields[fieldKey].errorMessage,
                    "danger"
                  );
                  messageContainer.appendChild(message);
                  console.log(`unable to update ${fieldKey}`);
                  console.error(error);
                  newrelic.noticeError(error);
                });
            }
          }
        });
      }

      // Enable the submit button if the user changes a value in one of the form fields
      profileForm.querySelectorAll("input, select").forEach((element) => {
        element.addEventListener("input", (event) =>
          profileForm
            .querySelector('[type="submit"]')
            .removeAttribute("disabled")
        );
      });
    } else {
      // The user logged in with their rewards number + PIN, so hide the form
      hideElement("[data-profile-form]");
      showElement("[data-profile-form-disabled-message]");
    }
  } else {
    // User is not logged in. Redirect to home page and prompt for authentication.
    UserAccount.forceAuthentication();
  }
}
